import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: [],
  // totalRows: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_SETTING:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
        items: [],
      }

    case ActionTypes.RECEIVE_SETTING:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        totalRows: action.items.dataCount,
        lastUpdated: action.receivedAt
      }
    
      case ActionTypes.TOTALROWS_SETTING:
        return {
          ...state,
          totalRows: action.totalRows,
          items: [],
        }
    
    default:
      return state
  }
}